import { FC } from "react";
import { Redirect } from "react-router-dom";
import withCompositeResource, { WrappedComponentProps } from "~/components/recource/CompositeResource";
import { useResourceRegister } from "~/utils/resourceRegister";
import { useHasFeature } from "~/utils/useHasFeature";


const SecureFileCompositeContent: FC<WrappedComponentProps> = ({
  children,
}) => {
  const hasFeature = useHasFeature()
  useResourceRegister({name: 'settings/governance/classification/data-access-role/grants'})
  useResourceRegister({name: 'secure-files-base-info-type'})

  if (!hasFeature.OnDataSecureFile) {
    return (
      hasFeature.requested ? <Redirect to="/" /> : null
    )
  }
  return (
    <>{children}</>
  )
}

export const SecureFileComposite = withCompositeResource(SecureFileCompositeContent);
